const removeUrlParam = (key, sourceURL) => {
    let rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString =
            sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (let i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
};

export const removeUrlStatusParams = (url) => {
    let cleanURL = url;

    cleanURL = removeUrlParam("code", cleanURL);
    cleanURL = removeUrlParam("session_state", cleanURL);
    cleanURL = removeUrlParam("error", cleanURL);
    cleanURL = removeUrlParam("error_description", cleanURL);

    return cleanURL;
};
